import { FC } from 'react';
import { TradeFormSubmitButton } from '../../MainTradeFormSubmitButton/MainTradeFormSubmitButton';
import { TradeFormProps } from '../types';
import { PoweredBy } from '../../../Reusable/PoweredBy/PoweredBy';

interface SubmitSectionProps {
  staticValues: TradeFormProps['staticValues'];
  loading: boolean;
  disabled: boolean;
  showPoweredBy?: boolean;
}

export const SubmitSection: FC<SubmitSectionProps> = ({
  staticValues,
  loading,
  disabled,
  showPoweredBy,
}) => {
  return (
    <>
      {showPoweredBy && (
        <PoweredBy
          value={staticValues.translatedValues.poweredByText}
          showLogo={!staticValues.translatedValues.poweredByText}
          noMargins
        />
      )}
      <TradeFormSubmitButton
        loading={loading}
        disabled={disabled}
        submitText={staticValues.translatedValues.confirmButtonText}
      />
    </>
  );
};
